import { useI18n } from "@/i18n/I18nProvider";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { InternalLinks } from "@/components/InternalLinks";
import { CasinoCard } from "@/components/CasinoCard";
import { listCasinos } from "@/data/casinos";

export function LiveCasinoPage() {
  const { t, lang, prefix } = useI18n();
  const isSv = lang === "sv";
  const casinos = listCasinos({ provider: "evolution" });
  const title = isSv ? "Live casino i Sverige 2026 — riktiga dealers i realtid" : "Live casino in Sweden 2026 — real dealers in real time";
  const desc = isSv
    ? "Live casino erbjuder riktiga dealers i realtid. Vanliga spel: blackjack, roulette, baccarat och liveshows som Crazy Time och Lightning Roulette."
    : "Live casino brings real-time dealers. Common games include blackjack, roulette, baccarat and live shows like Crazy Time and Lightning Roulette.";

  return (
    <div className="container-page py-8">
      <SEO title={title} description={desc} />
      <Breadcrumbs items={[{ label: t("nav.home"), href: prefix }, { label: title }]} />
      <h1 className="mt-3 text-3xl font-extrabold md:text-4xl">{title}</h1>
      <p className="mt-2 max-w-3xl text-ink-700">{desc}</p>

      <article className="prose prose-ink mt-6 max-w-3xl [&>h2]:mt-8 [&>h2]:mb-3 [&>h2]:text-2xl [&>h2]:font-bold [&>p]:my-3">
        <h2>{isSv ? "Hur live casino fungerar" : "How live casino works"}</h2>
        <p>
          {isSv
            ? "Live casino streamar bord i realtid från specialbyggda studior. En riktig dealer hanterar kort och hjul, medan du satsar via en digital meny. Den största leverantören är Evolution, med studior i Riga, Malta och Nordamerika. Pragmatic Play, Playtech och Authentic Gaming är andra stora aktörer."
            : "Live casino streams tables in real time from purpose-built studios. A real dealer handles cards and wheels while you bet via a digital menu. The biggest provider is Evolution with studios in Riga, Malta and North America. Pragmatic Play, Playtech and Authentic Gaming are other large players."}
        </p>
        <h2>{isSv ? "Vanliga live-spel" : "Common live games"}</h2>
        <ul className="mt-2 list-disc space-y-1 pl-6">
          <li>{isSv ? "Blackjack — klassiskt 21-spel med dealern." : "Blackjack — the classic 21 game vs the dealer."}</li>
          <li>{isSv ? "Roulette — europeisk, fransk och Lightning-versioner." : "Roulette — European, French and Lightning variants."}</li>
          <li>{isSv ? "Baccarat — Banker, Player eller Tie." : "Baccarat — Banker, Player or Tie."}</li>
          <li>{isSv ? "Crazy Time — game show med fyra bonusrundor." : "Crazy Time — game show with four bonus rounds."}</li>
          <li>{isSv ? "Monopoly Live — bonusrunda i Mr Monopolys 3D-värld." : "Monopoly Live — bonus rounds in Mr Monopoly's 3D world."}</li>
          <li>{isSv ? "Sweet Bonanza CandyLand — Pragmatics färgglada gameshow." : "Sweet Bonanza CandyLand — Pragmatic's colourful game show."}</li>
        </ul>
        <h2>{isSv ? "Tekniska krav" : "Technical requirements"}</h2>
        <p>
          {isSv
            ? "Live casino kräver bra internetuppkoppling — minst 5 Mbit/s rekommenderas. Spelet fungerar i webbläsaren utan separat app. På mobil är upplevelsen anpassad till porträttläge på de flesta moderna bord."
            : "Live casino requires a solid internet connection — at least 5 Mbps is recommended. It runs in the browser without a separate app. On mobile the experience is tailored to portrait mode on most modern tables."}
        </p>
      </article>

      <h2 className="mt-10 text-2xl font-bold">
        {isSv ? "Bästa live casino-sajterna" : "Best live casino sites"}
      </h2>
      <div className="mt-4 grid gap-4">
        {casinos.map((c, i) => (
          <CasinoCard key={c.id} casino={c} rank={i + 1} source="live-casino" />
        ))}
      </div>

      <InternalLinks context="casino-list" />
    </div>
  );
}
